import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationList } from '../../../../communication-structure/application-list';
import { CommunicationProxyService } from '../../../../services/communication-proxy.service';
import { LoginService } from '../../../../services/login.service';
import { StringTableService } from '../../../../services/string-table.service';
import { PageViewComponent } from '../../../page-view/page-view.component';
import { activeTrainingPageEnum, TrainingManagementComponent } from '../../training-management/training-management.component';

@Component({
  selector: 'app-reporting',
  templateUrl: './reporting.component.html',
  styleUrls: ['./reporting.component.scss']
})
export class ReportingComponent extends PageViewComponent implements OnInit {

  activePage: number;

  private applicationList: ApplicationList[];

  private currentAtcId: string;

  private currentAtcName: string;

  private previousAtcId: string;

  constructor(ele: ElementRef, remoteProxy: CommunicationProxyService,
    protected loginService: LoginService,
    stringTableService: StringTableService,
    protected router: Router
  ) {
    super(ele, remoteProxy, loginService, stringTableService, router);
    this.activePage = activeReportingPageEnum.reportingHome;
  }

  ngOnInit() {
    TrainingManagementComponent.setActiveTrainingPage(activeTrainingPageEnum.reporting);
  }

  changeActiveReportingPage(event) {
    this.activePage = event.activePage;
    this.applicationList = event.applicationList;
    this.currentAtcId = event.atcId;
    this.currentAtcName = event.atcName;
  }

  backToReport(event) {
    this.activePage = event.activePage;
    this.previousAtcId = event.autoTestId;
  }

}

export enum activeReportingPageEnum {
  reportingHome = 1,
  scoreDetails = 2
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/training-management/reporting-training/reporting/reporting.component.ts